import HttpService from "@core/services/http/http.service";
import {
  Banner,
  CreateBanner,
  GetDetailResponse,
  GetListResponse,
  UpdateBanner,
} from "@app/types";
import {
  RequestContentType,
  RequestParams,
  Signal,
} from "@core/services/http/http.type";

class _BannerService {
  public getList(
    requestParams?: RequestParams,
    signal?: Signal,
    isShowLoading?: boolean
  ) {
    return HttpService.get<GetListResponse<Banner>>("/admin/api/v2/banner", {
      queryParams: { ...requestParams },
      signal,
      isShowLoading,
    });
  }

  public get(bannerId: number) {
    return HttpService.get<GetDetailResponse<Banner>>(
      `/admin/api/v2/banner/${bannerId}`
    );
  }

  public create(createBanner: CreateBanner) {
    return HttpService.post("/admin/api/v2/banner", {
      body: { ...createBanner },
      requestContentType: RequestContentType.MULTIPART,
    });
  }

  public update(bannerId: number, updateBanner: UpdateBanner) {
    return HttpService.patch(`/admin/api/v2/banner/${bannerId}`, {
      body: { ...updateBanner },
      requestContentType: RequestContentType.MULTIPART,
    });
  }

  public delete(bannerId: number) {
    return HttpService.delete(`/admin/api/v2/banner/${bannerId}`);
  }
}

const BannerService = new _BannerService();

export default BannerService;
